var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.992,
    height: 55.992,
    viewBox: "0 0 55.992 55.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f067ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M54.242,20.94H1.75A1.748,1.748,0,0,1,0,19.195V6.4A6.412,6.412,0,0,1,6.416,0h43.16a6.412,6.412,0,0,1,6.416,6.4v12.8A1.748,1.748,0,0,1,54.242,20.94ZM3.5,17.45H52.492V6.4A2.916,2.916,0,0,0,49.576,3.49H6.416A2.916,2.916,0,0,0,3.5,6.4Z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M54.242,28.44H1.75A1.748,1.748,0,0,1,0,26.695V9.245A1.748,1.748,0,0,1,1.75,7.5H54.242a1.748,1.748,0,0,1,1.75,1.745v17.45A1.748,1.748,0,0,1,54.242,28.44ZM3.5,24.95H52.492V10.99H3.5Z",
    transform: "translate(0 10.026)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M49.576,35.94H6.416A6.412,6.412,0,0,1,0,29.542v-12.8A1.748,1.748,0,0,1,1.75,15H54.242a1.748,1.748,0,0,1,1.75,1.745v12.8A6.412,6.412,0,0,1,49.576,35.94ZM3.5,18.49V29.542A2.916,2.916,0,0,0,6.416,32.45h43.16a2.916,2.916,0,0,0,2.916-2.908V18.49Z",
    transform: "translate(0 20.052)",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(44.597 44.585)",
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(35.111 44.585)",
    fill: "url(#linear-gradient)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(25.645 44.585)",
    fill: "url(#linear-gradient)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(44.597 25.633)",
    fill: "url(#linear-gradient)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(35.111 25.633)",
    fill: "url(#linear-gradient)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(25.645 25.633)",
    fill: "url(#linear-gradient)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(44.597 9.466)",
    fill: "url(#linear-gradient)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(35.111 9.466)",
    fill: "url(#linear-gradient)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(25.645 9.466)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices5);
export default __webpack_public_path__ + "static/media/services5.d92029f14e0f93ac14b9c896d0bae7b5.svg";
export { ForwardRef as ReactComponent };